/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/QuizMeTabContainer.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { View } from 'foundations-components/components/View';
import CompanionTabWrapper from './CompanionTabWrapper.migrated';
import QuizMeTab from './QuizMeTab.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
const QuizMeTabContainer = ({
  additionalTracking,
  asyncGenerateError,
  asyncGenerateLoading,
  contentType,
  lesson,
  lessonContentId,
  onAsyncRegenerateQuiz,
  onRegenerateSingleVideoQuiz,
  primaryContentId
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
      children: /*#__PURE__*/_jsx(QuizMeTab, {
        additionalTracking: additionalTracking,
        asyncGenerateError: asyncGenerateError,
        asyncGenerateLoading: asyncGenerateLoading,
        contentType: contentType,
        lesson: lesson,
        lessonContentId: lessonContentId,
        onAsyncRegenerateQuiz: onAsyncRegenerateQuiz,
        onRegenerateSingleVideoQuiz: onRegenerateSingleVideoQuiz,
        primaryContentId: primaryContentId
      })
    })
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/QuizMeTabContainer.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default QuizMeTabContainer;